var navbar = (function() {
  /*
    Desktop menu version ->
  */
  var $navbar = $('#navbar-top')
  var $navbarPosEl = $('#nav-pos')
  var $sectionTopEl = $('#navbar-section-top')
  var $langSelectToggleEl = $navbar.find('.language-selection')
  var $langSelectEl = $('.navbar-lang-select')
  var $bottomSection = $('#navbar-section-bottom')
  var $desktopSection = $navbar.find('.navbar-menu-desktop')

  $(window).resize(function() {
    initNavbarPosHolder()
    adjustMobileNav()
  })
  $(document).ready(function() {
    initNavbarPosHolder()
  })

  function initNavbarPosHolder(val) {
    if (val) {
      $navbarPosEl.height(val)
    } else {
      $navbarPosEl.height($navbar.height())
    }
  }

  $langSelectToggleEl.click(function(e) {
      var Class = $(e.target).attr('class')
      if (Class === 'selection-item' || !Class) {
        return
      }
      $langSelectEl.slideToggle()
    })
    /*
  $bottomSection.delegate('.item, .item .selection', 'click', function(e) {
    //  stop close all event
    e.stopPropagation()
  })
  $bottomSection.delegate('.item, .item .selection', 'mouseenter', function(e) {
    var Class = $(e.target).attr('class')
    closeAllSiblings($(this))
    var $menu = $(this).find('.selection')
    $menu.stop().clearQueue()
    $menu.fadeIn(100)
  })
  $bottomSection.delegate('.item .selection', 'mouseleave', function(e) {
    closeAll()
  })

  $(window).click(function() {
    closeAll()
  })
*/
  function closeAllSiblings(elem) {
    $(elem).siblings('.item').find('.selection').fadeOut(100)
  }

  function closeAll() {
    $bottomSection.find('.item').find('.selection').fadeOut()
  }
  /*
    <- Desktop menu version
  */
  /*
    mobile menu section ->
  */
  var $closeButtonEl = $('#navbar-mobile-close')
  var $returnButtonEl = $('#navbar-mobile-return')
  var $headerEl = $('#navbar-mobile-header')
  var $toggleEl = $('#menu-toggle')
  var $navbarMobileEl = $headerEl.siblings('.menu-section')
  var $menuWrap = $navbarMobileEl.find('.menu-wrap')
  var $menuSections = $menuWrap.children('.menu')
  var $menuItems = $menuSections.children('.menu-item')
  var $menuItemsContent = $menuItems.children('.content')
  var $innerMenus = $menuItemsContent.siblings('.inner-menu')
  var actualPos = 0;

  $closeButtonEl.on('click', function() {
    animateToggle()
  })
  $returnButtonEl.on('click', function() {
    moveMobile($(this))
  })
  $toggleEl.on('click', function() {
      animateToggle()
    })
    /*
    $menuItems.children('.content').on('hover', function() {
      $(this).siblings('.inner-menu').slideToggle()
    })*/
  $($innerMenus.get(0)).children('.inner-menu-item').click(function() {
    moveMobile($(this))
  })

  function moveMobile(innerMenuItem) {
    var goTo = $(innerMenuItem).data('index');
    if (goTo || goTo === 0) {
      if (goTo !== 0) {
        $closeButtonEl.fadeOut(200, function() {
          $returnButtonEl.fadeIn()
        })
      } else {
        $returnButtonEl.fadeOut(200, function() {
          $closeButtonEl.fadeIn()
        })
      }
      var $goToEl = $menuSections.filter('[data-index="' + goTo + '"]')
      $menuWrap.animate({
        'margin-left': "+=" + (-($goToEl.offset().left)).toString()
      }, 500, function() {
        actualPos = goTo
      })
    }
  }

  function adjustMobileNav() {
    $menuWrap.css({
      'margin-left': -($(window).width()) * actualPos
    })
  }

  function animateToggle() {
    $headerEl.find('.menu-bars').toggleClass('fa-angle-down').toggleClass('fa-bars')
    $navbarMobileEl.slideToggle()
  }

  function animateClose() {
    $headerEl.find('.menu-bars').removeClass('fa-angle-down').addClass('fa-bars')
    $navbarMobileEl.fadeOut()
  }
  window.addEventListener("scroll", (function() {
      var top = document.body.scrollTop || document.documentElement.scrollTop
      if (top > 600) {
        $("#navbar-top")
          .addClass('fixed')
          .removeClass('animated fadeOutUp')
          .addClass('animated fadeInDown')
      } else if (top > 250) {
        animateClose()
        $("#navbar-top")
          .removeClass('animated fadeInDown')
          .addClass('animated fadeOutUp')
      } else {
        $("#navbar-top")
          .removeClass('fixed')
          .removeClass('animated fadeInDown')
          .removeClass('animated fadeOutUp')
      }
    }))
    /*
      <- mobile menu section
    */

  return {

  }
})()



// WEBPACK FOOTER //
// ./src/browser/oldJs/lib/navbar-top.js